import React, { useState } from "react"
import { Navigate } from "react-router-dom";
import { useGeneralContext } from "../../Contexts/GeneralContext/GeneralProvider";
import LoginModal from "../../Modals/LoginModals/LoginModal"
import LostPasswordModal from "../../Modals/LoginModals/LostPasswordModal";
import ConfirmPasswordModal from "../../Modals/LoginModals/ConfirmPasswordModal";
import { GetRedirectURL } from "../../Helpers/TranslateHelpers";
import './LoginPage.css'


function LoginPage() {

	const { authStatus, user } = useGeneralContext()

	const [loginModal, setLoginModal] = useState<"Login" | "LostPassword" | 'ConfimPassword'>('Login')
	const [userName, setUserName] = useState<string>('')

	if (authStatus === 'authenticated' && user) {
		return <Navigate to={GetRedirectURL(user.admin, user.school)} replace />
	}

	return (
		<div className="MainModalDiv">
			<div className="SwitchDiv">
				{(() => {
					switch (loginModal) {
						case 'Login':
							return <LoginModal
								setLoginModal={setLoginModal}
								setLoginUsername={setUserName}
							/>;
						case 'LostPassword':
							return <LostPasswordModal
								setLoginModal={setLoginModal}
							/>;
						case 'ConfimPassword':
							return <ConfirmPasswordModal
								setLoginModal={setLoginModal}
								loginUserName={userName}
							/>
						default:
							return <></>;
					}
				})()}
			</div>
		</div>
	)



}

export default LoginPage